import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { makeSpine } from "html-living-framework/lib/Utils/PixiUtils";
import {Ease} from "../core/Animatable";
import {IPoint, PointUtil} from "../core/Geom";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {AbstractCharacter} from "./AbstractCharacter";
import { LightsOutObject } from "./LightsOutObject";
import {TrashItem} from "./TrashItem";
import { TrashItemCollect } from "./TrashItemCollect";
import { TrashItemReturn } from "./TrashItemReturn";

export class Elmo extends AbstractCharacter {
    public readonly spine = this.addChild(makeSpine("elmo-profile"));

    protected grabcompleteCallback?: () => void;

    protected animations = {
        BLINK: "blink",
        IDLE: "idle",
        LIP_FLAP: "lip-flap",
        WALK: "walk",
        WAVE: "wave",
        GRAB_LOW: "grab-low",
        GRAB_MID: "grab-mid",
        GRAB_HIGH: "grab-high",
        SMILE: "easter-egg-smile",
    };

    constructor() {
        super("elmo");
    }

    public walkTo(x: number, speed: number, ease: gsap.Ease, callback: () => void, animationSpeed?: number) {
        const _grabCompleteCallback = this.grabcompleteCallback;
        if (_grabCompleteCallback) {
            this.grabcompleteCallback = undefined;
            console.log("grab interrupted");
            _grabCompleteCallback();
        }
        super.walkTo(x, speed, ease, callback, animationSpeed);
    }

    public Grab(pObject: LightsOutObject, pCallback?: () => void) {
        this.grabcompleteCallback = pCallback;

        const objectWorldPos = pObject.parent.toGlobal(pObject.position);
        const elmoWorldPos = this.parent.toGlobal(this.position);
        const objectRelativePos = this.parent.toLocal(objectWorldPos);
        objectRelativePos.y -= ((pObject.anchor.y - 0.5) * pObject.height);

        if (elmoWorldPos.x < objectWorldPos.x) {
            this.spine.scale.x = Math.abs(this.spine.scale.x);
        }
        else {
            this.spine.scale.x = Math.abs(this.spine.scale.x) * -1;
        }

        console.log (pObject.name + " y = " + objectRelativePos.y);

        if (objectRelativePos.y > 550) {
            console.log("grab low");
            this.spine.state.setAnimation(this.tracks.ARMS, this.animations.GRAB_LOW, false);
        }
        else if (objectRelativePos.y < 384) {
            console.log("grab high");
            this.spine.state.setAnimation(this.tracks.ARMS, this.animations.GRAB_HIGH, false);
        }
        else {
            console.log("grab mid");
            this.spine.state.setAnimation(this.tracks.ARMS, this.animations.GRAB_MID, false);
        }

        this.spine.state.addEmptyAnimation(this.tracks.ARMS, 0, 0);
    }

    protected onAnimationComplete(pEntry: PIXI.spine.core.TrackEntry) {
        super.onAnimationComplete(pEntry);
        switch (pEntry.animation.name) {
            case this.animations.GRAB_HIGH:
            case this.animations.GRAB_MID:
            case this.animations.GRAB_LOW:
                const _grabCompleteCallback = this.grabcompleteCallback;
                this.grabcompleteCallback = undefined;
                if (_grabCompleteCallback) {
                    console.log("grab complete");
                    _grabCompleteCallback();
                }
                break;
        }
    }
}
